import WServer from "./WServer";
import * as sessionHelper from "./sessionHelper";

const WS = window.WS = {
    VERSION: '3.0.0',
    WServer: WServer,
    ...sessionHelper.default
};
export default WS;
